<template>
  <main class="orange-loan-detail repayment-list">
    <section class="content-wrapper">
      <header class="header">
        <span>基础信息</span>
        <span class="id-no">{{ loanDetail.loanOrderId }}</span>
      </header>
      <div class="bill-info">
        <ul class="bill-list">
          <li>
            <span>借款服务商</span
            ><span>{{ loanDetail.loanProviderName }}</span>
          </li>
          <li>
            <span>借款金额</span
            ><span>￥{{ $utils.toYuan(loanDetail.loanAmount) }}</span>
          </li>
          <li>
            <span>申请日期</span><span>{{ loanDetail.loanOrderTime }}</span>
          </li>
          <li>
            <span>年费率</span
            ><span v-if="loanDetail.interestRate"
              >{{ handleRate(loanDetail.interestRate) }}%</span
            >
          </li>
          <li v-if="loanDetail.loanStatus === 50">
            <span>放款日期</span><span>{{ loanDetail.finishTime }}</span>
          </li>
          <li class="border-bottom">
            <span>还款方式</span><span>{{ loanDetail.repayTypeName }}</span>
          </li>
          <!-- <li class="border-bottom"><span>还款银行</span><span>农业银行</span></li> -->
        </ul>
        <ul class="bill-list">
          <li>
            <span>客户经理</span><span>{{ customer.customerManager }}</span>
          </li>
          <li>
            <span>联系方式</span
            ><span>{{ customer.customerManagerPhone }}</span>
          </li>
        </ul>
      </div>
      <header class="header car-title"><span>车辆信息</span></header>
      <div class="repay-order-list">
        <el-table :data="loanDetail.assets">
          <el-table-column prop="assetId" width="130px" label="资产编号">
          </el-table-column>
          <el-table-column prop="vinCode" width="130px" label="车架号">
          </el-table-column>
          <el-table-column prop="brandName" width="100px" label="品牌">
          </el-table-column>
          <el-table-column label="车系车型">
            <template slot-scope="scope">
              {{ scope.row.seriesName }} {{ scope.row.modelName }}
            </template>
          </el-table-column>
          <el-table-column width="80px" label="合同">
            <template slot-scope="scope">
              <el-popover placement="right" width="226" trigger="click">
                <ul class="contract-list" v-if="contractList.length">
                  <li v-for="(contract, index) in contractList" :key="index">
                    <a :href="contract.contractUrl" target="_blank"
                      >《{{ contract.contractName }}》</a
                    >
                  </li>
                </ul>
                <span
                  class="contract-btn"
                  @click.stop="getOwnContractList(scope.row.assetId)"
                  slot="reference"
                  type="text"
                  size="small"
                  >查看合同</span
                >
              </el-popover>
              <!-- <el-button type="text" size="small" @click="openAdvanceRepayDialog()">查看合同</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>
  </main>
</template>
<script>
import { mapState } from 'vuex'
import { toRate } from '../../../utils/unit-conversion'
export default {
  data() {
    return {
      contractList: [],
    }
  },
  computed: {
    ...mapState('loan', ['loanDetail', 'customer', 'assets']),
  },
  props: {
    loanOrderId: {
      type: String,
      required: true,
      default: '',
    },
  },
  methods: {
    handleRate(num) {
      return toRate(num)
    },
    getOwnContractList(id) {
      // 获取某个资产下的合同列表
      this.assets.forEach((item) => {
        if (item.assetId === id) {
          this.contractList = item.contracts
        }
      })
    },
  },
}
</script>

<style lang="stylus">
@import '../../../assets/css/common-color.styl'
.orange-loan-detail
  border 1px solid #E5E7E9
  box-shadow 0 6px 20px 0 rgba(220,223,230,0.28)
  border-radius 2px
  .el-table__empty-text
    color gray05
  .content-wrapper
    padding 24px 20px
    box-sizing border-box
    background url('../../../assets/images/contract/shuiyin.svg') repeat center
    background-size 100%
    .car-title
      margin-top -14px
    .header
      display flex
      justify-content space-between
      align-items center
      font-family PingFangSC-Medium
      font-size 16px
      color gray02
      span:first-child
        font-family PingFangSC-Medium
      .id-no
        font-size 14px
    .bill-info
      padding 0px 28px 40px 12px
      .bill-list
        margin-top 25px
        .border-bottom
          border-bottom 1px dashed #E5E7E9
          padding-bottom 30px
        li
          display flex
          justify-content space-between
          align-items center
          font-size 14px
          color gray03
          padding-bottom 14px
    .repay-order-list
      margin-top 12px
      .el-table thead
        color gray03
      .contract-btn
        color link-color
        cursor pointer
.el-popover
  .contract-list
    padding 14px 0 0 10px
    li
      font-size 14px
      margin-bottom 15px
      color link-color
      a
        text-decoration none
        color link-color
</style>
